/**
 * Parse a Lambda-via-AppSync response's `data` field.
 *
 * AppSync wraps custom-mutation / custom-query Lambda responses in a JSON
 * string. Our Lambdas return JSON.stringify(...) too, so we sometimes need
 * to parse twice to get the actual object. This helper normalises that.
 *
 * Usage:
 *   const result = await client.queries.someLambda(args);
 *   const data = parseLambdaResponse<MyShape>(result?.data);
 */
export function parseLambdaResponse<T = any>(raw: unknown): T | undefined {
  if (raw == null) return undefined;
  let v: any = raw;
  // Unwrap up to two levels of JSON string encoding.
  if (typeof v === 'string') {
    try { v = JSON.parse(v); } catch { return undefined; }
  }
  if (typeof v === 'string') {
    try { v = JSON.parse(v); } catch { return undefined; }
  }
  return v as T;
}
